import { hyperdbHandlers } from 'hyperdb-utils';

export default hyperdbHandlers({ namespace: 'OWNER' });



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/owner/handlers.js